import { render, staticRenderFns } from "./ctf-rich-text-embed-asset.vue?vue&type=template&id=8f63a30a&"
import script from "./ctf-rich-text-embed-asset.vue?vue&type=script&lang=js&"
export * from "./ctf-rich-text-embed-asset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports